export default __webpack_public_path__ + "static/media/logo_transparent.3c5386e5.png";